<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToScrollPoint'
});
</script>
<template>
	<div :id="'scroll-point-' + String(props.value).replace(/\s+/g, '-')" ref="pointRef" class="to-scroll-point" :class="{ active: isActive }" :data-point-value="props.value" :data-point-active="isActive ? 'true' : 'false'">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, inject, watch, nextTick, computed, onBeforeUnmount } from 'vue'
import { scrollPointProps } from './scroll-point'
import { ScrollContext } from './scroll'



const props = defineProps(scrollPointProps)

const pointRef = ref<HTMLElement | null>(null)
const parentValue = inject<any>('scrollValue', ref(null))
const isActive = computed(() => parentValue?.value === props.value)

// 处理滚动点激活事件
const handleScrollPointActive = (event: CustomEvent) => {
	if (event.detail && event.detail.value === props.value) {
		// 当激活状态改变时触发
	}
}

// 注入父滚动组件提供的上下文
const parentScroll = inject<ScrollContext | null>('ToScroll', null)

// 注册滚动点到父组件
const registerToParent = () => {
	if (parentScroll && pointRef.value) {
		parentScroll.registerScrollPoint(pointRef.value, props.value)
	} else {
		// 无法注册到父组件
	}
}

// 在挂载后注册自身到父组件
onMounted(() => {
	// 等待 DOM 更新完成后注册
	nextTick(() => {
		registerToParent()

		// 添加自定义事件监听
		if (pointRef.value) {
			pointRef.value.addEventListener('scroll-point-active', handleScrollPointActive as EventListener)
		}
	})
})

// 组件销毁前移除事件监听
onBeforeUnmount(() => {
	if (pointRef.value) {
		pointRef.value.removeEventListener('scroll-point-active', handleScrollPointActive as EventListener)
	}
})

// 监听值变化，更新数据属性
watch(
	() => props.value,
	() => {
		nextTick(() => {
			registerToParent()
		})
	}
)

// 监听父组件的值变化
watch(
	() => parentValue?.value,
	() => {
		// 当父值变化时，会自动通过computed属性更新isActive状态
	}
)

// 导出方法供父组件调用
defineExpose({
	pointRef,
	getValue: () => props.value
})
</script>
